import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { AuditFrequencyModel } from 'src/app/views/Audit/project-list/models/audit-frequency.model';
import { ManagerInfoModel } from 'src/app/views/Audit/project-list/models/manager-info.model';
import { ProjectFilter } from 'src/app/views/Audit/project-list/models/project-filter';
import { AuditedProjectResult, ProjectInfo } from 'src/app/views/Audit/project-list/models/project-info.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectListingService {

  private gsdAPIUrl = environment.GSDapiUrl;

  constructor(private http: HttpClient) { 

  }


  getAuditFrequencyOptions(): Observable<Array<AuditFrequencyModel>>{
    const endPointUrl:string = `AuditCreation/GetAuditFrequencies`;
    return this.http.get<AuditFrequencyModel[]>(this.gsdAPIUrl+ endPointUrl);   
  }


  getAuditedProjects():Observable<AuditedProjectResult>{
    const requestUrl = `${this.gsdAPIUrl}AuditCreation/GetAuditedProjects`;
    return this.http.get<AuditedProjectResult>(requestUrl);
  }

  searchProjects(filter:ProjectFilter):Observable<ProjectInfo[]>{
    const requestUrl = `${this.gsdAPIUrl}AuditCreation/GetAuditedProjects?ProjectTechStackId=${filter.name}`;
    return this.http.get<ProjectInfo[]>(requestUrl);
  }

  getManagersName():Observable<ManagerInfoModel[]>{
    const requestUrl = `${this.gsdAPIUrl}AuditCreation/GetManagerName`;
    return this.http.get<ManagerInfoModel[]>(requestUrl);
  }
}
